import Spinner from '@leshen/ui/dist/esm/packages/ui/src/components/MegaForm/Spinner'
import React, { Suspense, lazy } from 'react'
import { useMapi } from '../context/MapiProvider'

const C = lazy(() =>
  import('@leshen/ui/dist/esm/packages/ui/src/components/Cart')
)

const brandMap = {
  EMB: {
    brand: 'CTL',
    experience: 'default',
  },
  QF: {
    brand: 'CTL',
    experience: 'qtm',
  },
  BSP: {
    brand: 'BSP',
    experience: 'default',
  },
}

const Cart = () => {
  const {
    brandToken,
    requestId,
    rotatedNumber,
    sessionPromoCode,
    brandTokens,
  } = useMapi()

  const env = process.env.LOCATION === 'production' ? 'prod' : 'stage'

  if (!requestId || !sessionPromoCode) {
    return <Spinner />
  }

  const [bt] = brandTokens || []
  const rr = brandMap[bt] || brandMap[brandToken] || {}
  const { brand = brandToken, experience = 'default' } = rr

  return (
    <Suspense fallback={<Spinner />}>
      <C
        env={env}
        brand={brand}
        experience={experience}
        promo={sessionPromoCode}
        phoneNumber={rotatedNumber || '555-555-5555'}
        requestId={requestId}
      />
    </Suspense>
  )
}

const CartClient = () => <Cart />

export default CartClient
